var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMedalSilver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_405)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8588 31.0663C29.9506 27.7476 33.8199 18.4977 30.5013 10.4059C27.1826 2.31416 17.9326 -1.55519 9.84087 1.76348C1.74912 5.08215 -2.12023 14.3321 1.19844 22.4239C4.51711 30.5156 13.7671 34.385 21.8588 31.0663Z",
    fill: "url(#paint0_linear_75_405)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97086 40.3827L6.8037 37.5675C6.5691 37.4502 6.4518 37.3329 6.09989 37.3329L2.11162 36.9809C1.87702 36.9809 1.64241 36.629 1.75972 36.3944L7.39022 23.4912L16.3052 27.3622L10.5574 40.2654C10.5574 40.5 10.0882 40.6173 9.85356 40.3827H9.97086Z",
    fill: "url(#paint1_linear_75_405)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8187 40.3827L24.9858 37.5675C25.2204 37.4502 25.3377 37.3329 25.6897 37.3329L29.6779 36.9809C29.9125 36.9809 30.1471 36.629 30.0298 36.3944L24.3993 23.4912L15.4844 27.3622L21.2322 40.2654C21.2322 40.5 21.7014 40.6173 21.936 40.3827H21.8187Z",
    fill: "url(#paint2_linear_75_405)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4427 26.9529C32.3063 21.0893 32.3063 11.5826 26.4427 5.71897C20.5791 -0.144622 11.0724 -0.144624 5.20877 5.71897C-0.654824 11.5826 -0.654824 21.0893 5.20877 26.9529C11.0724 32.8165 20.5791 32.8165 26.4427 26.9529Z",
    fill: "url(#paint3_linear_75_405)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6229 24.1328C27.929 19.8267 27.929 12.8452 23.6229 8.5391C19.3169 4.23303 12.3353 4.23303 8.02926 8.5391C3.72318 12.8452 3.72318 19.8267 8.02926 24.1328C12.3353 28.4388 19.3169 28.4388 23.6229 24.1328Z",
    fill: "url(#paint4_linear_75_405)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39499 16.9225C5.39499 10.8228 10.3217 5.89608 16.4214 5.89608C22.5211 5.89608 21.9346 7.0691 23.9287 8.82863C21.9346 6.7172 19.1193 5.30957 15.9522 5.30957C9.85247 5.30957 4.92578 10.2363 4.92578 16.336C4.92578 22.4357 6.33341 22.3184 8.44484 24.3125C6.56801 22.3184 5.51229 19.7377 5.51229 16.8052L5.39499 16.9225Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8349 5.42687H15.6003C21.2308 5.54417 25.8055 10.119 25.8055 15.8668C25.8055 21.6146 21.1135 26.3066 15.3657 26.3066C9.61786 26.3066 5.04308 21.7319 4.92578 16.1014V16.336C4.92578 22.4357 9.85247 27.3624 15.9522 27.3624C22.0519 27.3624 26.9786 22.4357 26.9786 16.336C26.9786 10.2363 22.0519 5.30957 15.9522 5.30957L15.8349 5.42687Z",
    fill: "#9B9B9B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5398 20.5371V19.1931C12.8104 18.7264 13.1184 18.3064 13.4638 17.9331C13.8184 17.5504 14.2198 17.1584 14.6678 16.7571C15.0318 16.4398 15.3258 16.1738 15.5498 15.9591C15.7831 15.7444 15.9511 15.5484 16.0538 15.3711C16.1658 15.1844 16.2218 14.9838 16.2218 14.7691C16.2218 14.2184 15.8438 13.9431 15.0878 13.9431C14.6864 13.9431 14.2898 13.9898 13.8978 14.0831C13.5151 14.1764 13.1558 14.2978 12.8198 14.4471V11.9131C13.2118 11.7544 13.6738 11.6284 14.2058 11.5351C14.7471 11.4324 15.3024 11.3811 15.8718 11.3811C17.0291 11.3811 17.8878 11.6518 18.4478 12.1931C19.0171 12.7251 19.3018 13.4298 19.3018 14.3071C19.3018 14.7084 19.2551 15.0584 19.1618 15.3571C19.0684 15.6464 18.9238 15.9171 18.7278 16.1691C18.5318 16.4118 18.2704 16.6778 17.9438 16.9671C17.7104 17.1724 17.4631 17.3871 17.2018 17.6111C16.9498 17.8351 16.7584 18.0451 16.6278 18.2411H19.3718V20.5371H12.5398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_405",
    x1: 0.0933007,
    y1: 16.3989,
    x2: 31.8822,
    y2: 16.3989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_405",
    x1: 6.92101,
    y1: 36.2771,
    x2: 9.50165,
    y2: 30.7639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A00505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_405",
    x1: 24.5166,
    y1: 36.1598,
    x2: 22.0533,
    y2: 30.1774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A00505"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_405",
    x1: 0.804341,
    y1: 0.493427,
    x2: 30.951,
    y2: 0.493427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_405",
    x1: 22.271,
    y1: 22.7808,
    x2: 8.78124,
    y2: 9.29108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7889,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedalSilver);
export default __webpack_public_path__ + "static/media/icon-medal-silver.5c97b2806c8606c7e76d68a7d18a0e97.svg";
export { ForwardRef as ReactComponent };